module.exports = __webpack_public_path__ + "static/image/font/pc/bmhannaair-5@3x.ver2_0_2.jpg?db2cdb58";